/**
 * The session's tenancy identity, as the bootstrap needs it.
 *
 * `customerClaim` is the single `customer` value carried on the auth token; `null` for a
 * `regard_admin`, who carries no customer and may access any of them.
 */
export interface Identity {
  isAdmin: boolean
  customerClaim: string | null
}

/**
 * Resolves the session's tenancy identity for the post-auth bootstrap.
 *
 * STUBBED, matching arc's copy of this seam: returns a `regard_admin` with no customer
 * claim, so the app boots into the customer-list path and the header's picker has
 * something to offer.
 *
 * The real implementation will read the top-level `customer` and `regard_admin` claims off
 * the Auth0 access token, which is where outpatient already reads them from (see
 * `auth/regard_internal.py`). Deferring it keeps the unverified SMART-on-FHIR
 * token-exchange plumbing out of this change. This hook is the single seam to swap when it
 * lands — nothing else reads identity directly.
 */
export const useIdentity = (): Identity => {
  return { isAdmin: true, customerClaim: null }
}
